import React from "react";

const EditCategory = () => {
  return (
    <div>
      <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal px-6">
        Services
      </p>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-2 border-b-2 border-[#000] w-fit pl-4 pr-10">
          Edit Category
        </p>
      </div>
      <section className="flex flex-col w-full lg:w-3/5 gap-8 px-0 lg:px-6 mt-6">
        <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm  overflow-hidden">
          <p className="flex items-center ">
            Category Name:{" "}
            <input className="ml-0 lg flex-grow bg-[#fff] rounded-lg px-1 "></input>
          </p>
        </div>
        <div className="flex lg:block w-full justify-center items-center">
          <button className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal rounded-md w-1/2 lg:w-1/4 ">
            Save Changes
          </button>
        </div>
      </section>
    </div>
  );
};

export default EditCategory;
